import {SignalsService} from "@vicman-wi/telemetry-js/esm/signals/SignalsService";
import {stringIsTrueValue} from "@vicman-wi/utils-js/esm/string/is-true-value";
import {stringToNumbers} from "@vicman-wi/utils-js/esm/string/to-numbers";
import logger from "./logger";

let instance = null;

/** @return {SignalsService} */
export function getSignalsService() {
  if (instance) return instance;

  const userGroups = stringToNumbers(process.env.REACT_APP_SIGNALS_USER_GROUPS);

  instance = new SignalsService(
    {
      isEnabled: stringIsTrueValue(process.env.REACT_APP_SIGNALS_ENABLED),
      isMuted: userGroups.indexOf(window.clientConfig.splitGroupId) === -1,
      defaultGroup: window.appConfig.project.name,
    },
    logger()
  );

  return instance;
};